import React, { useMemo } from "react";
import { CartonComment } from "../../../../../../models/carton";
import { Grid } from "@mui/material";
import {
  CommentAvatar,
  CommentCard,
  CommentHeader,
  CommentHeaderInfo,
  CommentSubtitle,
  CommentText,
  CommentTitle,
  DeleteCommentIcon,
} from "./styles";
import { colors } from "@zapalacorp/tokens";
import { useTranslation } from "react-i18next";
import { format } from "date-fns-tz";
import { useAppState } from "../../../../../../context/StateContext";

interface CommentItemProps {
  comment: CartonComment;
  handleDeleteComment: () => void;
}

export const CommentItem = ({ comment, handleDeleteComment }: CommentItemProps) => {
  const { t: translate } = useTranslation();
  const { currentUser } = useAppState();
  const { id, user } = comment;
  const actualUser = useMemo(() => (id ? user : currentUser), [user, currentUser]);

  return (
    <CommentCard item xs={12}>
      <CommentHeader>
        <CommentAvatar src={actualUser?.picture?.mediaLink} />
        <CommentHeaderInfo>
          <CommentTitle>{actualUser?.fullName}</CommentTitle>
          <CommentSubtitle>
            {comment.createdAt
              ? `${translate("addedOn")}: ${format(
                  new Date(comment.createdAt),
                  "dd/MM/yyyy hh:mm a"
                )}`
              : null}
          </CommentSubtitle>
        </CommentHeaderInfo>
        <DeleteCommentIcon
          onClick={() => handleDeleteComment()}
          color={colors.error500}
          size={20}
        />
      </CommentHeader>
      <CommentText>{comment.message}</CommentText>
    </CommentCard>
  );
};
